import api from './api';

export const qrcodeService = {
  generate: async (partId: number) => {
    const response = await api.post(`/qrcode/generate/${partId}`);
    return response.data;
  },

  scan: async (qrData: string) => {
    const response = await api.post('/qrcode/scan', { qr_data: qrData });
    return response.data;
  },

  generateBulk: async (partIds: number[]) => {
    const response = await api.post('/qrcode/generate-bulk', { part_ids: partIds });
    return response.data;
  },
};

export const transactionService = {
  getAll: async (params?: any) => {
    const response = await api.get('/transactions', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/transactions/${id}`);
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/transactions', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/transactions/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/transactions/${id}`);
    return response.data;
  },
};

export const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  getChartData: async (type: string, startDate: string, endDate: string) => {
    const response = await api.get('/dashboard/chart-data', {
      params: { type, start_date: startDate, end_date: endDate },
    });
    return response.data;
  },
};

export const machineService = {
  getAll: async (params?: any) => {
    const response = await api.get('/machines', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/machines/${id}`);
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/machines', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/machines/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/machines/${id}`);
    return response.data;
  },
};

export const categoryService = {
  getAll: async () => {
    const response = await api.get('/categories');
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/categories', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/categories/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
  },
};

export const supplierService = {
  getAll: async (params?: any) => {
    const response = await api.get('/suppliers', { params });
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/suppliers', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/suppliers/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/suppliers/${id}`);
    return response.data;
  },
};

export const sparePartService = {
  getAll: async (params?: any) => {
    const response = await api.get('/spare-parts', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/spare-parts/${id}`);
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/spare-parts', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/spare-parts/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/spare-parts/${id}`);
    return response.data;
  },

  getLowStock: async () => {
    const response = await api.get('/spare-parts/low-stock');
    return response.data;
  },

  updateStock: async (id: number, quantity: number, operation: string) => {
    const response = await api.patch(`/spare-parts/${id}/stock`, { quantity, operation });
    return response.data;
  },
};

export const maintenanceService = {
  getAll: async (params?: any) => {
    const response = await api.get('/maintenance', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/maintenance/${id}`);
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/maintenance', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/maintenance/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/maintenance/${id}`);
    return response.data;
  },
};

export const technicianService = {
  getAll: async (params?: any) => {
    const response = await api.get('/technicians', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/technicians/${id}`);
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/technicians', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/technicians/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/technicians/${id}`);
    return response.data;
  },
};

export const storeService = {
  getAll: async () => {
    const response = await api.get('/stores');
    return response.data;
  },

  getPartStock: async (partId: number) => {
    const response = await api.get(`/stores/part/${partId}/stock`);
    return response.data;
  },

  updatePartStock: async (partId: number, storeId: number, data: any) => {
    const response = await api.put(`/stores/part/${partId}/store/${storeId}`, data);
    return response.data;
  },

  getAllPartsWithStores: async () => {
    const response = await api.get('/stores/parts-with-stores');
    return response.data;
  },
};

export { userService } from './userService';
export { default as purchaseRequisitionService } from './purchaseRequisition.service';

// PFP Trolly Stock Service
export const pfpTrollyStockService = {
  getAll: async (params?: any) => {
    const response = await api.get('/pfp-trolly-stock', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/pfp-trolly-stock/${id}`);
    return response.data;
  },

  getByQrCode: async (qrCode: string) => {
    const response = await api.get(`/pfp-trolly-stock/qr/${encodeURIComponent(qrCode)}`);
    return response.data;
  },

  getByBatchNumber: async (batchNumber: string) => {
    const response = await api.get(`/pfp-trolly-stock/batch/${batchNumber}`);
    return response.data;
  },

  getActiveBatches: async () => {
    const response = await api.get('/pfp-trolly-stock/active-batches');
    return response.data;
  },

  getStatistics: async () => {
    const response = await api.get('/pfp-trolly-stock/statistics');
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string) => {
    const response = await api.get('/pfp-trolly-stock/date-range', {
      params: { start_date: startDate, end_date: endDate },
    });
    return response.data;
  },

  getTrollyItems: async (batchNumber: string) => {
    const response = await api.get(`/pfp-trolly-stock/trolly-items/${batchNumber}`);
    return response.data;
  },

  getAvailableTrollies: async (batchNumber: string) => {
    const response = await api.get(`/pfp-trolly-stock/available-trollies/${batchNumber}`);
    return response.data;
  },

  uploadFabricationCSV: async (formData: FormData) => {
    const response = await api.post('/pfp-trolly-stock/upload-fabrication-csv', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/pfp-trolly-stock', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/pfp-trolly-stock/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/pfp-trolly-stock/${id}`);
    return response.data;
  },

  addTrollyToBatch: async (batchNumber: string, data: { trolly_number: string; quantity_kg: number; location?: string; remarks?: string }) => {
    const response = await api.post(`/pfp-trolly-stock/${batchNumber}/add-trolly`, data);
    return response.data;
  },

  updateTrollyItem: async (id: number, data: { trolly_number?: string; location?: string }) => {
    const response = await api.put(`/pfp-trolly-stock/trolly-item/${id}`, data);
    return response.data;
  },

  linkTrolleyToLocation: async (data: { trolley_qr_code: string; slot_qr_code?: string; location?: string }) => {
    const response = await api.post('/pfp-trolly-stock/link-location', data);
    return response.data;
  },

  unlinkTrolleyFromLocation: async (trolleyQrCode: string) => {
    const response = await api.post('/pfp-trolly-stock/unlink-location', { trolley_qr_code: trolleyQrCode });
    return response.data;
  },

  transferTrollyLoad: async (batchNumber: string, data: { from_trolly_number: string; to_trolly_number: string; transfer_quantity: number }) => {
    const response = await api.post(`/pfp-trolly-stock/${batchNumber}/transfer-trolly`, data);
    return response.data;
  },
};

// PFP Trolly Release Service
export const pfpTrollyReleaseService = {
  getAll: async (params?: any) => {
    const response = await api.get('/pfp-trolly-releases', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/pfp-trolly-releases/${id}`);
    return response.data;
  },

  getByStockId: async (stockId: number) => {
    const response = await api.get(`/pfp-trolly-releases/stock/${stockId}`);
    return response.data;
  },

  getStatistics: async () => {
    const response = await api.get('/pfp-trolly-releases/statistics');
    return response.data;
  },

  getDailySummary: async (date: string) => {
    const response = await api.get('/pfp-trolly-releases/daily-summary', {
      params: { date },
    });
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string) => {
    const response = await api.get('/pfp-trolly-releases/date-range', {
      params: { start_date: startDate, end_date: endDate },
    });
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/pfp-trolly-releases', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/pfp-trolly-releases/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/pfp-trolly-releases/${id}`);
    return response.data;
  },
};

// Maintenance Record Service
export const maintenanceRecordService = {
  getAll: async (params?: any) => {
    const response = await api.get('/maintenance-records', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/maintenance-records/${id}`);
    return response.data;
  },

  getStats: async (params?: any) => {
    const response = await api.get('/maintenance-records/stats', { params });
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/maintenance-records', data);
    return response.data;
  },

  update: async (id: number, data: any) => {
    const response = await api.put(`/maintenance-records/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/maintenance-records/${id}`);
    return response.data;
  },
};

export const wasteManagementService = {
  getAll: async (params?: any) => {
    const response = await api.get('/waste-management', { params });
    return response.data;
  },

  getSummary: async (params?: any) => {
    const response = await api.get('/waste-management/summary', { params });
    return response.data;
  },

  sync: async () => {
    const response = await api.post('/waste-management/sync');
    return response.data;
  },

  updatePfpIn: async (id: number, pfpInWeight: number) => {
    const response = await api.put(`/waste-management/${id}/pfp-in`, {
      pfp_in_weight_lbs: pfpInWeight,
    });
    return response.data;
  },

  updateAfterPrint: async (id: number, afterPrintWeight: number) => {
    const response = await api.put(`/waste-management/${id}/after-print`, {
      after_print_weight_lbs: afterPrintWeight,
    });
    return response.data;
  },

  getCutWasteRecords: async () => {
    const response = await api.get('/waste-management/cut-waste');
    return response.data;
  },

  createCutWasteRecords: async (data: {
    waste_type: 'cut_waste' | 'cotton_waste';
    entries: Array<{
      section: 'digital' | 'rotary' | 'paste' | 'post_production' | 'other';
      other_section_name?: string;
      weight_kg: number;
    }>;
  }) => {
    const response = await api.post('/waste-management/cut-waste', data);
    return response.data;
  },

  getCutWasteAnalytics: async (params: { period: 'monthly' | 'yearly'; year?: number }) => {
    const response = await api.get('/waste-management/cut-waste/analytics', { params });
    return response.data;
  },
};